import { whyUsers } from '@/mocks/siteData';

export default function WhyUsersSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold mb-4 whitespace-nowrap">
            User Benefits
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Why Users Search For Sugargoo Spreadsheet
          </h2>
          <p className="text-foreground-500 max-w-2xl mx-auto text-sm leading-relaxed">
            Thousands of shoppers turn to Sugargoo Spreadsheet resources every day. Here is what they are looking for and how our platform delivers.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {whyUsers.map((item, idx) => (
            <div
              key={idx}
              className="group p-6 bg-background-100 rounded-xl border border-background-200/60 hover:border-accent-200 transition-all duration-300 cursor-default"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}